import { formatDate } from '@angular/common';
import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { toValidDate } from '../utils/date-helper';

import { ActivityItemComponent } from '../components/activity-item/activity-item.component';
import { CourseDetailDialogComponent } from '../components/Dialogs/course-detail-dialog/course-detail-dialog.component';
import { CreateAbsenceDialogComponent } from '../components/Dialogs/create-absence-dialog/create-absence-dialog.component';
import { CreateBeratungsprotokollComponent } from '../components/Dialogs/create-beratungsprotokoll-dialog/create-beratungsprotokoll-dialog.component';
import { CreateConsultationDialogComponent } from '../components/Dialogs/create-consultation-dialog/create-consultation-dialog.component';
import { CreateContactDialogComponent } from '../components/Dialogs/create-contact-dialog/create-contact-dialog.component';
import { CreateCourseDialogComponent } from '../components/Dialogs/create-course-dialog/create-course-dialog.component';
import { CreateEignungstestDialogComponent } from '../components/Dialogs/create-eignungstest-dialog/create-eignungstest-dialog.component';
import { CreateIhkEducationVoucherDialogComponent } from '../components/Dialogs/create-ihkeducationvoucher-dialog/create-ihkeducationvoucher-dialog.component';
import { CreateLearnsuccesscontrolDialogComponent } from '../components/Dialogs/create-learnsuccesscontrol-dialog/create-learnsuccesscontrol-dialog.component';
import { CreateNoteDialogComponent } from '../components/Dialogs/create-note-dialog/create-note-dialog.component';
import { CreateSponsorDialogComponent } from '../components/Dialogs/create-sponsor-dialog/create-sponsor-dialog.component';
import { ChangePasswordDialogComponent } from '../components/Dialogs/change-password-dialog/change-password-dialog.component';
import { CreateUserDialogComponent } from '../components/Dialogs/create-user-dialog/create-user-dialog.component';
import { SaveEmailComponent } from '../components/Dialogs/save-email/save-email.component';
import { DocumentsDialogComponent } from '../components/Dialogs/dokuments-dialog/dokuments-dialog.component';
import { PresenceDialogComponent } from '../components/zoom-dialog-deaktiviert/presence..component';

import { InventoryDialogComponent } from '../components/Dialogs/inventory-dialog/inventory-dialog.component';
import { InventoryImportDialogComponent } from '../components/Dialogs/inventory-import-dialog/inventory-import-dialog.component';
import { InventoryCategoryDialogComponent } from '../components/Dialogs/inventory-category-dialog/inventory-category-dialog.component';
import { ListsettingsDialogComponent } from '../components/Dialogs/listsettings-dialog/listsettings-dialog.component';
import { PdfCertificateDialogComponent } from '../pdf-signer/components/pdf-certificate-dialog/pdf-certificate-dialog.component';

import { Activity } from '../models/activity.model';
import { AbsencePrefill } from '../models/absence.model';
import { Course } from '../models/course.model';
import { user } from '../models/user.model';
import {
  TODO_ACTIVITY_TYPES,
  TODO_ACTIVITY_TYPE,
  TodoActivityType,
} from '../workflow/workflow-types';
import { DialogResult } from '../workflow/models/dialog-result.model';
import { CourseListCourseDetailDialog } from '../components/Dialogs/course-list-course-detail-dialog/course-list-course-detail-dialog';
import { OnlineMeeting } from '@microsoft/microsoft-graph-types';
import { TeamsMeetingDialog } from '../components/Dialogs/teams-meeting-dialog/teams-meeting-dialog';
import { CourseType } from '../models/course-type.model';
import { Location } from '../models/location.model';
import { CourseUsersDialog } from '../components/Dialogs/course-users-dialog/course-users-dialog';
import { ListItem } from '../models/ListItem.model';
import { ClassbookEntryDialogComponent } from '../components/Dialogs/classbook-entry-dialog/classbook-entry-dialog.component';
import { ClassbookDialogInput } from '../models/classbook-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class DialogManagerService {
  consultationRef: DynamicDialogRef | null = null;
  userRef: DynamicDialogRef | null = null;
  courseRef: DynamicDialogRef | null = null;
  sponsorRef: DynamicDialogRef | null = null;
  activityDetailsRef: DynamicDialogRef | null = null;
  emailRef: DynamicDialogRef | null = null;
  eignungstestRef: DynamicDialogRef | null = null;
  eignungstestInvitationRef: DynamicDialogRef | null = null;
  beratungsprotokollRef: DynamicDialogRef | null = null;
  IhkEducationVoucherRef: DynamicDialogRef | null = null;
  noteRef: DynamicDialogRef | null = null;
  contactRef: DynamicDialogRef | null = null;
  pdfCertificateRef: DynamicDialogRef | null = null;
  absenceRef: DynamicDialogRef | null = null;
  learningRef: DynamicDialogRef | null = null;
  coursedetailRef: DynamicDialogRef | null = null;
  presenceRef: DynamicDialogRef | null = null;
  activityRef: DynamicDialogRef | null = null;

  inventoryRef: DynamicDialogRef | null = null;
  inventoryImportRef: DynamicDialogRef | null = null;
  inventoryCategoryRef: DynamicDialogRef | null = null;

  courseListCourseDetailRef: DynamicDialogRef | null = null;
  courseUsersDialogRef: DynamicDialogRef | null = null;
  teamsMeetingDialogRef: DynamicDialogRef | null = null;
  listSettingsRef: DynamicDialogRef | null = null;
  classbookEntryRef: DynamicDialogRef | null = null;

  private todoActivityTypes = TODO_ACTIVITY_TYPES;

  public registry = new Map<TodoActivityType, Type<any>>([
    [
      TODO_ACTIVITY_TYPE.UPLOAD_DOCUMENT,
      CreateIhkEducationVoucherDialogComponent,
    ],
    [TODO_ACTIVITY_TYPE.CONSULTATION, CreateConsultationDialogComponent],
    [TODO_ACTIVITY_TYPE.GENERAL_CONTACT, CreateContactDialogComponent],
    [TODO_ACTIVITY_TYPE.STORE_EMAIL, SaveEmailComponent],
    [TODO_ACTIVITY_TYPE.SHOW_USER_DETAILS, CreateUserDialogComponent],
    [TODO_ACTIVITY_TYPE.APTITUDE_TEST, CreateEignungstestDialogComponent],
  ]);

  constructor(private dialogService: DialogService) {}

  openActivityDialog(type: TodoActivityType, data?: any): DynamicDialogRef {
    const component = this.registry.get(type);
    if (!component) {
      throw new Error(`Keine Dialog-Komponente für Typ ${type} registriert`);
    }

    this.activityRef = this.dialogService.open(component, {
      header:
        this.todoActivityTypes.find((t) => t.value === type)?.label ??
        'Details',
      baseZIndex: 10000,
      draggable: true,
      data,
    });

    return this.activityRef;
  }

  openActivityDetails(params: { activityId?: number }): DynamicDialogRef {
    this.activityDetailsRef = this.dialogService.open(ActivityItemComponent, {
      header: 'Aktivitätsdetails',
      baseZIndex: 10000,
      height: '90vh',
      style: { 'max-height': '1024px' },
      draggable: true,
      data: { activity: params.activityId },
    });

    return this.activityDetailsRef;
  }

  closeActivityDetails(result?: DialogResult) {
    if (this.activityDetailsRef) {
      this.activityDetailsRef.close(result);
      this.activityDetailsRef = null;
    }
  }

  openUserDialog(params: {
    selectedUser?: user;
    showAllRoles: boolean;
    header: string;
    preselectedRole?: number | null;
    lecturerUsers?: user[]; // Für teams-meeting-preview.
  }) {
    this.userRef = this.dialogService.open(CreateUserDialogComponent, {
      header: params.header,
      baseZIndex: 10000,
      draggable: true,
      data: {
        selectedUser: params.selectedUser,
        showAllRoles: params.showAllRoles,
        preselectedRole: params.preselectedRole,
        lecturerUsers: params.lecturerUsers,
      },
    });

    return this.userRef;
  }

  closeUserDialog(result?: DialogResult) {
    if (this.userRef) {
      this.userRef.close();
      this.userRef = null;
    }
    if (this.activityRef) {
      this.activityRef.close(result);
    }
  }

  openConsultationDialog(params: {
    user?: user;
    activityToUpgrade?: Activity;
  }) {
    this.consultationRef = this.dialogService.open(
      CreateConsultationDialogComponent,
      {
        header: 'Beratungsgespräch',
        baseZIndex: 10000,
        draggable: true,
        data: {
          selectedUser: params.user,
          activityToUpgrade: params.activityToUpgrade,
        },
      },
    );

    return this.consultationRef;
  }

  closeConsultationDialog(result?: DialogResult) {
    if (this.consultationRef) {
      this.consultationRef.close(result);
      this.consultationRef = null;
    }
    if (this.activityRef) {
      this.activityRef.close(result);
    }
  }

  openCourseDialog() {
    this.courseRef = this.dialogService.open(CreateCourseDialogComponent, {
      header: 'Kurs anlegen',
      baseZIndex: 10000,
      draggable: true,
    });
    return this.courseRef;
  }

  closeCourseDialog() {
    if (this.courseRef) {
      this.courseRef.close();
      this.courseRef = null;
    }
  }

  openSponsorDialog() {
    this.sponsorRef = this.dialogService.open(CreateSponsorDialogComponent, {
      header: 'Kostenträger anlegen',
      baseZIndex: 10000,
      draggable: true,
    });
    return this.sponsorRef;
  }

  closeSponsorDialog() {
    if (this.sponsorRef) {
      this.sponsorRef.close();
      this.sponsorRef = null;
    }
  }

  openChangePasswordDialog(username: string): DynamicDialogRef {
    return this.dialogService.open(ChangePasswordDialogComponent, {
      header: 'Passwort ändern',
      data: { username },
      baseZIndex: 10000,
      width: '32rem',
      breakpoints: { '640px': '95vw' },
    });
  }

  openEmailDialog(params: { user?: user; activityToUpgrade?: Activity }) {
    this.emailRef = this.dialogService.open(SaveEmailComponent, {
      header: 'E-Mail ablegen',
      baseZIndex: 10000,
      draggable: true,
      data: {
        user: params.user,
        activityToUpgrade: params.activityToUpgrade,
      },
    });

    return this.emailRef;
  }

  closeEmailDialog(result?: DialogResult) {
    if (this.emailRef) {
      this.emailRef.close();
      this.emailRef = null;
    }
    if (this.activityRef) {
      this.activityRef.close(result);
    }
  }

  openEignungstestDialog(params: {
    user?: user;
    activityToUpgrade?: Activity;
  }) {
    this.eignungstestRef = this.dialogService.open(
      CreateEignungstestDialogComponent,
      {
        header: 'Eignungstest',
        baseZIndex: 10000,
        draggable: true,
        data: {
          selectedUser: params.user,
          activityToUpgrade: params.activityToUpgrade,
        },
      },
    );

    return this.eignungstestRef;
  }

  closeEignungstestDialog(result?: DialogResult) {
    if (this.eignungstestRef) {
      this.eignungstestRef.close(result);
      this.eignungstestRef = null;
    }
    if (this.activityRef) {
      this.activityRef.close(result);
    }
  }

  openBeratungsprotokollDialog(params: {
    user?: user;
    activityToUpgrade?: Activity;
  }) {
    this.beratungsprotokollRef = this.dialogService.open(
      CreateBeratungsprotokollComponent,
      {
        header: 'Beratungsprotokoll',
        baseZIndex: 10000,
        draggable: true,
        data: {
          user: params.user,
          activityToUpgrade: params.activityToUpgrade,
        },
      },
    );

    return this.beratungsprotokollRef;
  }

  closeBeratungsprotokollDialog() {
    if (this.beratungsprotokollRef) {
      this.beratungsprotokollRef.close();
      this.beratungsprotokollRef = null;
    }
  }

  openIHKEducationvoucherDialog(params: {
    user?: user;
    activityToUpgrade?: Activity;
  }) {
    this.IhkEducationVoucherRef = this.dialogService.open(
      CreateIhkEducationVoucherDialogComponent,
      {
        header: 'Dokumentenupload',
        baseZIndex: 10000,
        draggable: true,
        data: {
          selectedUser: params.user,
          activityToUpgrade: params.activityToUpgrade,
        },
      },
    );
    return this.IhkEducationVoucherRef;
  }

  closeIHKEducationvoucherDialog(result?: DialogResult) {
    if (this.IhkEducationVoucherRef) {
      this.IhkEducationVoucherRef.close(result);
      this.IhkEducationVoucherRef = null;
    }
    if (this.activityRef) {
      this.activityRef.close(result);
    }
  }

  openNotizDialog(params: { user?: user; activityToUpgrade?: Activity }) {
    this.noteRef = this.dialogService.open(CreateNoteDialogComponent, {
      header: 'Notiz',
      baseZIndex: 10000,
      draggable: true,
      data: {
        selectedUser: params.user,
        activityToUpgrade: params.activityToUpgrade,
      },
    });
    return this.noteRef;
  }

  closeNotizDialog() {
    if (this.noteRef) {
      this.noteRef.close();
      this.noteRef = null;
    }
  }

  openContactDialog(params: { user?: user; activityToUpgrade?: Activity }) {
    this.contactRef = this.dialogService.open(CreateContactDialogComponent, {
      header: 'Allegemeiner Kontakt',
      baseZIndex: 10000,
      draggable: true,
      data: {
        selectedUser: params.user,
        activityToUpgrade: params.activityToUpgrade,
      },
    });

    return this.contactRef;
  }

  closeContactDialog(result?: DialogResult) {
    if (this.contactRef) {
      this.contactRef.close();
      this.contactRef = null;
    }
    if (this.activityRef) {
      this.activityRef.close(result);
    }
  }

  openAbsenceDialog(params: {
    user?: user;
    activityToUpgrade?: Activity;
    absencePrefill?: AbsencePrefill;
  }): DynamicDialogRef {
    this.absenceRef = this.dialogService.open(CreateAbsenceDialogComponent, {
      header: 'Abwesenheit erfassen',
      baseZIndex: 10000,
      draggable: true,
      data: {
        selectedUser: params.user,
        activityToUpgrade: params.activityToUpgrade,
        absencePrefill: params.absencePrefill,
      },
    });

    return this.absenceRef;
  }

  closeAbsenceDialog() {
    if (this.absenceRef) {
      this.absenceRef.close();
      this.absenceRef = null;
    }
  }

  openLearningDialog(params: { user?: user; activityToUpgrade?: Activity }) {
    this.learningRef = this.dialogService.open(
      CreateLearnsuccesscontrolDialogComponent,
      {
        header: 'Lernerfolgskontrolle',
        baseZIndex: 10000,
        draggable: true,
        data: {
          selectedUser: params.user,
          activityToUpgrade: params.activityToUpgrade,
        },
      },
    );
    return this.learningRef;
  }

  closeLearningDialog() {
    if (this.learningRef) {
      this.learningRef.close();
      this.learningRef = null;
    }
  }

  openCourseDetailDialog(course: Course) {
    this.coursedetailRef = this.dialogService.open(
      CourseDetailDialogComponent,
      {
        data: { course },
        header: `Kurs: ${course.courseName}`,
        width: '600px',
        baseZIndex: 10000,
        draggable: true,
      },
    );
    return this.coursedetailRef;
  }

  closeCourseDetailDialog() {
    if (this.coursedetailRef) {
      this.coursedetailRef.close();
      this.coursedetailRef = null;
    }
  }

  openDocumentsDialog(data: any = {}) {
    return this.dialogService.open(DocumentsDialogComponent, {
      header: 'Dokumente',
      width: '60%',
      data,
    });
  }

  openInventoryDialog(params: {
    mode: 'hardware' | 'category';
    hardwareCategories?: any[];
    participants?: any[];
    courses?: any[];
    inventory?: any;
  }): DynamicDialogRef {
    // Beim Bearbeiten wird ein vorhandener Eintrag durchgereicht.
    const header =
      params.mode === 'category'
        ? 'Kategorien verwalten'
        : params.inventory
          ? 'Inventar bearbeiten'
          : 'Inventar hinzufügen';

    this.inventoryRef = this.dialogService.open(InventoryDialogComponent, {
      header,
      baseZIndex: 10000,
      draggable: true,
      width: params.mode === 'hardware' ? '800px' : '500px',
      data: {
        mode: params.mode,
        hardwareCategories: params.hardwareCategories,
        participants: params.participants,
        courses: params.courses,
        inventory: params.inventory,
      },
    });

    return this.inventoryRef;
  }

  closeInventoryDialog() {
    if (this.inventoryRef) {
      this.inventoryRef.close();
      this.inventoryRef = null;
    }
  }

  openInventoryImportDialog(): DynamicDialogRef {
    this.inventoryImportRef = this.dialogService.open(
      InventoryImportDialogComponent,
      {
        header: 'Inventar importieren',
        baseZIndex: 10000,
        draggable: true,
        width: '950px',
      },
    );

    return this.inventoryImportRef;
  }

  openPdfCertificateDialog(): DynamicDialogRef {
    this.pdfCertificateRef = this.dialogService.open(
      PdfCertificateDialogComponent,
      {
        header: 'Signaturzertifikat verwalten',
        baseZIndex: 10000,
        draggable: true,
        width: '600px',
      },
    );

    return this.pdfCertificateRef;
  }

  closePdfCertificateDialog() {
    if (this.pdfCertificateRef) {
      this.pdfCertificateRef.close();
      this.pdfCertificateRef = null;
    }
  }

  closeInventoryImportDialog() {
    if (this.inventoryImportRef) {
      this.inventoryImportRef.close();
      this.inventoryImportRef = null;
    }
  }

  openInventoryCategoryDialog(): DynamicDialogRef {
    this.inventoryCategoryRef = this.dialogService.open(
      InventoryCategoryDialogComponent,
      {
        header: 'Kategorien verwalten',
        baseZIndex: 10000,
        draggable: true,
        width: '650px',
      },
    );

    return this.inventoryCategoryRef;
  }

  openPresenceDialog() {
    this.presenceRef = this.dialogService.open(PresenceDialogComponent, {
      header: 'Zoom-Anwesenheitsliste',
      baseZIndex: 10000,
      draggable: true,
    });
  }

  closePresenceDailog() {
    if (this.presenceRef) {
      this.presenceRef.close();
      this.presenceRef = null;
    }
  }

  openCourseListCourseDetailDialog(
    course: Course,
    courseTypes: CourseType[],
    locations: Location[],
    allUsers: user[],
  ) {
    this.courseListCourseDetailRef = this.dialogService.open(
      CourseListCourseDetailDialog,
      {
        header: `${course.courseName}`,
        width: '600px',
        draggable: true,
        data: {
          course,
          courseTypes,
          locations,
          allUsers,
        },
      },
    );
  }

  closeCourseListCourseDetailDialog() {
    if (this.courseListCourseDetailRef) {
      this.courseListCourseDetailRef.close();
      this.courseListCourseDetailRef = null;
    }
  }

  openTeamsMeetingDialogDocent(
    docentName: string,
    users: user[],
    onCloseAction: Function,
    meeting?: OnlineMeeting,
  ): void {
    this.teamsMeetingDialogRef = this.dialogService.open(TeamsMeetingDialog, {
      header: this.buildDocentMeetingDialogHeader(docentName, meeting),
      width: '50%',
      draggable: true,
      data: {
        docentName,
        meeting,
        users,
        meetingServiceType: 'docent',
      },
    });

    this.teamsMeetingDialogRef.onClose.subscribe((result) => {
      onCloseAction(result);
      this.teamsMeetingDialogRef = null;
    });
  }

  // Ohne Meeting legt der Dialog einen Stapel an, mit Meeting bearbeitet er einen Termin.
  private buildDocentMeetingDialogHeader(
    docentName: string,
    meeting?: OnlineMeeting,
  ): string {
    if (!meeting) {
      return `Fehlende Meetings erstellen für ${docentName}`;
    }

    const day = toValidDate(meeting.startDateTime as string | undefined);
    return day
      ? `Meeting von ${docentName} am ${formatDate(day, 'dd.MM.yyyy', 'de-DE')}`
      : `Meeting von ${docentName}`;
  }

  openTeamsMeetingDialogCourse(
    courseName: string,
    users: user[],
    onCloseAction: Function,
    meeting?: OnlineMeeting,
  ): void {
    this.teamsMeetingDialogRef = this.dialogService.open(TeamsMeetingDialog, {
      header: `Selbststudium Teams Meeting für Kurs: ${courseName.trim()}`,
      width: '50%',
      draggable: true,
      data: {
        courseName,
        meeting,
        users,
        meetingServiceType: 'course',
      },
    });

    this.teamsMeetingDialogRef.onClose.subscribe((result) => {
      onCloseAction(result);
      this.teamsMeetingDialogRef = null;
    });
  }

  openCourseUsersDialog(
    courseDialogHeader: string,
    course: Course,
    availableUsers: user[],
  ): void {
    this.courseUsersDialogRef = this.dialogService.open(CourseUsersDialog, {
      header: courseDialogHeader,
      closable: true,
      draggable: true,
      data: {
        course,
        availableUsers,
      },
    });
  }

  openListSettingsDialog(params: {
    item?: ListItem;
    listSettingsId?: number;
    listSettingsName: string;
    header: string;
  }): DynamicDialogRef {
    this.listSettingsRef = this.dialogService.open(
      ListsettingsDialogComponent,
      {
        header: params.header,
        width: '450px',
        data: {
          item: params.item ?? { listSettingsId: params.listSettingsId },
          listSettingsName: params.listSettingsName,
        },
      },
    );

    return this.listSettingsRef;
  }

  closeListSettingsDialog() {
    if (this.listSettingsRef) {
      this.listSettingsRef.close();
      this.listSettingsRef = null;
    }
  }

  // hash: aus dem öffentlichen Stundenplan durchgereicht; sonst läuft das Speichern über die Sitzung.
  openClassbookEntryDialog(
    entry: ClassbookDialogInput,
    hash?: string,
  ): DynamicDialogRef {
    this.classbookEntryRef = this.dialogService.open(
      ClassbookEntryDialogComponent,
      {
        header: 'Klassenbuch-Eintrag',
        width: '820px',
        breakpoints: { '960px': '95vw' },
        data: { entry, hash },
      },
    );

    return this.classbookEntryRef;
  }

  /**
   * Schließt hier bewusst nicht selbst: der Dialog gibt über ref.close(gespeichert) zurück, ob
   * ein Eintrag angelegt wurde. Ein zusätzliches close() würde dieses Ergebnis überschreiben.
   */
  closeClassbookEntryDialog() {
    this.classbookEntryRef = null;
  }
}
